import React, { FunctionComponent } from 'react';

import { IPrismicRoute } from '@/pageGeneration/services/prismicApi/types';

import LinksSection from '@/components/landingPages/LinksSection';

interface IProps {
  routes: IPrismicRoute[];
}

const RouteSection: FunctionComponent<IProps> = ({ routes }) => <LinksSection links={routes} title="Routes" />;

export default RouteSection;
